<template>
  <a-simple-tooltip @tooltip-close="$emit('tooltip-close')">
    <template #text>
      {{ $translate('post.tooltip.postEdit.titleA') }}
      <strong class="anz-strong">
        {{ $translate('post.tooltip.postEdit.titleB') }}
      </strong>
      {{ $translate('post.tooltip.postEdit.titleC') }}
      <strong
        class="anz-strong"
        v-if="configuration.widget.subscriptionLinkDisabled"
      >
        {{ $translate('post.tooltip.postEdit.titleLink') }}
      </strong>
      <a-button
        v-else
        add-href
        :href="generateBuyPremiumSubscriptionRoute(POST_TOOLTIP_EDIT)"
        :title="$translate('post.tooltip.postEdit.titleLink')"
        class-name="anz-link anz-color-primary anz-link-underline anz-strong"
      />
    </template>
  </a-simple-tooltip>
</template>

<script lang="ts">
import { defineComponent } from 'vue'
import { TOOLTIP_COMPONENTS } from '@/composables/post/postTooltip'
import { useRouter } from '@/routing/router'
import ASimpleTooltip from '@/components/Ui/ASimpleTooltip.vue'
import AButton from '@/components/Forms/AButton.vue'
import useConfiguration from '@/composables/configuration/configuration'
import { OfferLinkPosition } from '@/routing/refManager'

export default defineComponent({
  name: TOOLTIP_COMPONENTS.POST_EDIT,
  emits: ['tooltip-close'],
  components: { AButton, ASimpleTooltip },
  props: {
    alreadyPerformed: {
      type: Boolean,
      default: false,
    },
    post: {
      type: Object,
      required: true,
    },
  },
  data() {
    return {
      checked: false,
      POST_TOOLTIP_EDIT: OfferLinkPosition.POST_TOOLTIP_EDIT,
    }
  },
  setup() {
    return {
      ...useRouter(),
      ...useConfiguration(),
    }
  },
})
</script>
